module.exports = __webpack_public_path__ + "static/media/ArrowRightIcon.ca853d6f.svg";